// extracted by mini-css-extract-plugin
export default {"button":"secondary-small__button___Vs3d3 primary-small__button___76QBp primary__button___frFdc base__button___zT0JW"};